export const ADD_NEXT_INVOICE = 'ADD_NEXT_INVOICE';
export const CLEAR_NEXT_INVOICE = 'CLEAR_NEXT_INVOICE';
export const ADD_GLOBAL_ERROR = 'ADD_GLOBAL_ERROR';
export const CLEAR_GLOBAL_ERROR = 'CLEAR_GLOBAL_ERROR';
export const SET_HEADER_TOOLTIP_TEXT = 'SET_HEADER_TOOLTIP_TEXT';
export const TOGGLE_CARD_DRAWER = 'TOGGLE_CARD_DRAWER';
export const TOGGLE_PAYMENT_DRAWER = 'TOGGLE_PAYMENT_DRAWER';
export const START_LOADING = 'START_LOADING';
export const STOP_LOADING = 'STOP_LOADING';
export const ADD_GLOBAL_WARNING = 'ADD_GLOBAL_WARNING';
export const CLEAR_GLOBAL_WARNING = 'CLEAR_GLOBAL_WARNING';
export const ADD_LOCATION_LIST = 'ADD_LOCATION_LIST';
export const ADD_BILL_TO_SITE_NUMBER = 'ADD_BILL_TO_SITE_NUMBER';
export const ADD_CUSTOM_ERROR = 'ADD_CUSTOM_ERROR';
export const CLEAR_CUSTOM_ERROR = 'CLEAR_CUSTOM_ERROR';
export const ADD_ALERT_DETAILS = 'ADD_ALERT_DETAILS';
export const CLEAR_ALERT_DETAILS = 'CLEAR_ALERT_DETAILS';
export const SET_SUMMARY_PAGE_FLAG = 'SET_SUMMARY_PAGE_FLAG';
